export default __webpack_public_path__ + "static/media/dispatched_hover_cached.589ffd01.svg";